import axios from "axios";
import config from "../config";

export function generateAvatar(name, length) {
  return axios.get(
    `${config.api_url}/generate-avatar?name=${name}&length=${length}`,
    { responseType: "blob" }
  );
}
